"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var templates_1 = require("./templates");
exports.default = {
    framework: 'semantic',
    templates: templates_1.default,
};
